module.exports = __webpack_public_path__ + "static/pistola_final_4-7baad5185eec5786f0f712e73a7ce5cb.png";